import { render, staticRenderFns } from "./EditClient.vue?vue&type=template&id=033a24eb"
import script from "./edit-client.js?vue&type=script&lang=js&external"
export * from "./edit-client.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports